import React from 'react';
import { T } from './traks';
import Me from './Me';

/* returns the first argument that's not `undefined`. or returns `undefined`,
 * if all arguments are `undefined` */
function coalesce() {
	for (var i = 0; i < arguments.length; i++) {
		var arg = arguments[i];
		if (arg !== undefined) return arg;
	}
	return undefined;
}

function parse_date(dstr) {
	if (!dstr) return null;
	const xs = dstr.split("-");
	if (xs.length !== 3) return null;
	const yyyy = parseInt(xs[0], 10);
	const mm1 = parseInt(xs[1], 10);
	const dd = parseInt(xs[2], 10);
	if (yyyy === 0 && mm1 === 0 && dd === 0) return null;
	return new Date(yyyy, mm1-1, dd);
}

function check_date(dval) {
	if (dval instanceof Date) return dval;
	return parse_date(dval);
}

/* if n=3 and xs=[1,2,3,4,5,6,7,8], this will return [[1,2,3],[4,5,6],[7,8]] */
function segmentize(n, xs) {
	var segments = [];
	var segment = [];
	for (const x of xs) {
		segment.push(x);
		if (xs.length >= n) {
			segments.push(segment);
			segment = [];
		}
	}
	if (segment.length > 0) segments.push(segment);
	return segments;
}

function array2set(xs) {
	var set = {};
	for (var x of (xs||[])) set[x] = true;
	return set;
}

function setCommodityName(ticker, name) {
    if (ticker === 'CANE') {
        return <T>Sugar</T>
    } else if (ticker === 'CPER') {
        return <T>Copper</T>
    } else if (ticker === 'GLD') {
        return <T>Gold</T>
    } else if (ticker === 'IYM') {
        return <T>Aluminium</T>
    } else if (ticker === 'LIT') {
        return <T>Lithium</T>
    } else if (ticker === 'PALL') {
        return <T>Palladium</T>
    } else if (ticker === 'PPLT') {
        return <T>Platinum</T>
    } else if (ticker === 'SLV') {
        return <T>Silver</T>
    } else if (ticker === 'SLX') {
        return <T>Steel</T>
    } else if (ticker === 'UNG') {
        return <T>Natural Gas</T>
    } else if (ticker === 'URA') {
        return <T>Uranium</T>
    } else if (ticker === 'USO') {
        return <T>Oil</T>
    } else if (ticker === 'WEAT') {
        return <T>Wheat</T>
    } else if (ticker === 'NIKL') {
        return <T>Nickel</T>
    } else if (ticker === 'WOOD') {
        return <T>Timber</T>
    }

    return name;
}

function validatePremium(me) {
	if (me.TempSubscription === undefined) {
		me.TempSubscription = 'free';
	}
    if (me && (me.Subscription.includes('pro', 'enterprise') || me.TempSubscription.includes('pro', 'enterprise'))) {
        return true;
    }

    return false;
}

function validatePremiumGame(game_info) {
    if (!game_info || !game_info.Premium) {
        game_info.Premium = 'free';
    }

    if (game_info.Premium === 'pro' || game_info.Premium === 'enterprise') {
        return true;
    }

    return false;
}

function dataPlaceholder(data, placeholder = '-') {
    if (!data || data === 0 || `${data}`.length === 0) {
        return placeholder;
    } else {
        return data;
    }
}

const formatWithSeparators = (num) => {
    const [integerPart, decimalPart] = num.toString().split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return decimalPart ? `${formattedIntegerPart},${decimalPart}` : formattedIntegerPart;
};

const checkUserAge = (userBirthDate) => {
    const currentDate = new Date();
    let age = currentDate.getFullYear() - userBirthDate.getFullYear();

    const monthDiff = currentDate.getMonth() - userBirthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < userBirthDate.getDate())) {
        age--;
    }

    return age;
}

const getPremiumUpgradeTarget = () => {
    const me = Me.get();
    return me && me.User && validatePremium(me.User) ? '/cart' : getCurrentlyPremiumPage();
};

const getCurrentlyPremiumPage = () => {
    // WP premium sales page.
    // Intentionally structured for future multi-domain support.
    if (IS_AKTIEDYSTEN_DK) {
        return 'https://undervisning.aktiedysten.dk/premium-undervisning/';
    } else if (IS_AKTIEKAMPEN_SE) {
        return 'https://undervisning.aktiekampen.se/premium-foretag/';
    } else if (IS_INVESTSPIEL_DE) {
        return 'https://bildung.investspiel.de/premium-bildung/';
    } else if (IS_TRADERR_COM) {
        return 'https://together.traderr.com/fantasy-stock-game/';
    }

    // Fallback until additional domains are live
    return 'https://undervisning.aktiedysten.dk/premium-undervisning/';
};

const PENDING_CART_GAME_ID_KEY = 'cart.pending_game_id';

const setPendingCartGameId = (gameId) => {
    if (!gameId) return;
    const parsed = parseInt(gameId, 10);
    if (!Number.isFinite(parsed)) return;

    const payload = {
        game_id: String(parsed),
        ts: Date.now(),
    };

    try {
        sessionStorage.setItem(PENDING_CART_GAME_ID_KEY, JSON.stringify(payload));
    } catch (err) {
        // ignore storage errors
    }
};

const consumePendingCartGameId = (maxAgeMs = 60 * 60 * 1000) => {
    const safeRemove = () => {
        try { sessionStorage.removeItem(PENDING_CART_GAME_ID_KEY); } catch (e) {}
    };

    let raw;
    try {
        raw = sessionStorage.getItem(PENDING_CART_GAME_ID_KEY);
    } catch (err) {
        return null;
    }

    if (!raw) return null;

    let payload;
    try {
        payload = JSON.parse(raw);
    } catch (err) {
        safeRemove();
        return null;
    }

    if (!payload || !payload.game_id || !payload.ts) {
        safeRemove();
        return null;
    }

    const ts = Number(payload.ts);
    if (!Number.isFinite(ts) || (Date.now() - ts) > maxAgeMs) {
        safeRemove();
        return null;
    }

    safeRemove();
    return payload.game_id;
};

// Params are optional and only used for tracking/preselects.
const goToPremiumSalesPage = (params = {}) => {
    const base = getCurrentlyPremiumPage();
    const pairs = [];

    for (const [key, value] of Object.entries(params || {})) {
        if (value === null || value === undefined) continue;
        const str = String(value);
        if (str.length === 0) continue;
        pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(str)}`);
    }

    const query = pairs.length > 0 ? `${base.includes('?') ? '&' : '?'}${pairs.join('&')}` : '';
    window.location.assign(`${base}${query}`);
};

const vaildateDiversifications = (diversificationRules, userDiversification, activeMarkets) => {
    const TYPE_TO_CLASS = {
        Equity: "stocks",
        Index: "bonds",
        "Funds/Obligations": "bonds",
        ETF: "bonds",
        Commodity: "commodities",
        Crypto: "crypto",
    };

    const STOCK_TYPE_TO_MARKETS = {
        stocks: ["US_STOCK", "DK_STOCK", "SE_STOCK", "FI_STOCK", "IS_STOCK", "DE_STOCK", "AT_STOCK"],
        bonds: ["FUNDS", "ETFS", "INDEXES"],
        commodities: ["COMMODITIES"],
        crypto: ["CRYPTOCURRENCIES"],
    };

    if (!Array.isArray(diversificationRules) || diversificationRules.length === 0) {
        return {};
    }

    // Create a fast lookup set for active markets
    const activeSet = new Set(activeMarkets);

    // 1. Aggregate user's diversification values per stock_type
    const userByClass = {};
    for (const { Type, Value } of userDiversification || []) {
        
        const cls = TYPE_TO_CLASS[Type];
        if (!cls) continue; // unknown type is ignored
        userByClass[cls] = (userByClass[cls] || 0) + (Number(Value) || 0);
    }

    // 2. Compare user diversification with the required rules
    const missing = {};
    for (const rule of diversificationRules) {
        const cls = rule.stock_type;               // "stocks" | "bonds" | "commodities" | "crypto""

        // Skip validation if no markets for this type are currently active
        const linkedMarkets = STOCK_TYPE_TO_MARKETS[cls] || [];
        const hasActive = linkedMarkets.some((m) => activeSet.has(m));
        if (!hasActive) continue; // skip this rule entirely

        const required = Number(rule.procents) || 0;
        const current = Number(userByClass[cls] || 0);

        // If user's diversification in this class is below the required threshold
        if (current + 1e-9 < required) {
            missing[cls] = {
                required,
                current: Math.round(current * 100) / 100,
            };
        }
    }

    // Return an empty object if all requirements are met, 
    // otherwise return the classes that failed and their values
    return Object.keys(missing).length === 0 ? {} : missing;
}

export {
	coalesce,
	parse_date,
	check_date,
	segmentize,
	array2set,
    validatePremium,
    dataPlaceholder,
	formatWithSeparators,
    setCommodityName,
	validatePremiumGame,
    checkUserAge,
    vaildateDiversifications,
    getCurrentlyPremiumPage,
    setPendingCartGameId,
    consumePendingCartGameId,
    goToPremiumSalesPage,
    getPremiumUpgradeTarget,
};



// WEBPACK FOOTER //
// ./src/misc.js